module.exports = __webpack_public_path__ + "static/media/img2.424d7ae5.jpeg";